export default "__VITE_ASSET__DOpa7aCZ__"